import React, {useState} from 'react';
import {Link, ScrollRestoration, useLoaderData, useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {VTForm} from 'vt-components'
import { getExcursionInfo } from "server/getExcursionInfo";
import SEO from "components/SEO/SEO";
import Slide from "./Slide/Slide";
import useGetZone from "../../hooks/useGetZone";

//CSS
import styles from "./excursion.module.less"

export async function loader({ params }) {

  const response = await getExcursionInfo(params.slug, params.language);

  if(process.env.REACT_APP_DEBUG === 'true') console.log("[EXCURSION] -> Loader");
  if(process.env.REACT_APP_DEBUG === 'true') console.log("response", response);

  if (!response.error){
    return response.data;
  }else{
    throw new Error("Loader excursión:", { cause: response.error })
  }
}

export default function Excursion() {
  const excursionInfo = useLoaderData();
  const {t,i18n} = useTranslation("pages");
  const zone  = useGetZone();
  const [showWebText, setShowWebText] = useState(false);
  const navigate = useNavigate();
  const formconfig={
    product:excursionInfo.id,
    collaborator:1111,
    locale:i18n.language,
    linktocart:()=>navigate("/cart"),
    debug:process.env.REACT_APP_DEBUG
  }
  const webtext=<div className={styles.text} dangerouslySetInnerHTML={{__html: excursionInfo.webtext}}></div>;

  let excursionsIncludes="";
  let excursionsNOIncludes="";

  if (excursionInfo.hasOwnProperty('excursionsincludes')){
    if (excursionInfo.excursionsincludes.hasOwnProperty('1')){
      excursionsIncludes = excursionInfo.excursionsincludes[1].map((include,index)=>{
        return (
          <li key={index}>{include}</li>
        )
      });
    }
    if (excursionInfo.excursionsincludes.hasOwnProperty('0')){
      excursionsNOIncludes = excursionInfo.excursionsincludes[0].map((include,index)=>{
        return (
          <li key={index}>{include}</li>
        )
      });
    }
  }

  const groupSlug= excursionInfo?.excursionsgroup?.[0]?.slug ?? null;
  const groupName= excursionInfo?.excursionsgroup?.[0]?.name ?? null;

  return(
    <>
      <SEO title={excursionInfo.weburltitle} description={excursionInfo.weburltitle} name='Viajes Teide' type='excursion' />

      {excursionInfo.images && <Slide images={excursionInfo.images}/>}

      <div className={styles.excursion}>

        <div className={styles.info}>
          <div className={styles.breadcrumbs}>
            <Link to={'/' + i18n.language + '/search/' + zone}>{t('zona')} {zone}</Link>

            {groupSlug && groupName &&
              <>
                >
                <Link to={'/' + i18n.language + '/search/' + zone + '/' + excursionInfo.excursionsgroup[0].slug}>{excursionInfo.excursionsgroup[0].name}</Link>
              </>
            }

          </div>
          <div className={styles.title}>{excursionInfo.webtitle}</div>
          <div className={styles.abstract}>
            {excursionInfo.webabstract}
            &nbsp;
            {!showWebText && <span className={styles.readmore} onClick={()=>setShowWebText(!showWebText)}>{t('excursion.readmore')}</span>}
          </div>
          {showWebText && webtext}
          {showWebText && <span className={styles.readmore} onClick={()=>setShowWebText(!showWebText)}>{t('excursion.readless')}</span>}
        </div>

        <div className={styles.form}>
          <VTForm config={formconfig} />
        </div>

        <div className={styles.tips}>
          <div className={styles.title}></div>
          <div className={styles.text} dangerouslySetInnerHTML={{__html: excursionInfo.webinterest}}></div>
        </div>

        {excursionsIncludes &&
          <div className={styles.includes}>
            <div className={styles.title}>{t('excursion.include')}</div>
            <div className={styles.items}>{excursionsIncludes}</div>
          </div>
        }

        {excursionsNOIncludes &&
          <div className={styles.includes}>
            <div className={styles.title}>{t('excursion.noinclude')}</div>
            <div className={styles.items}>{excursionsNOIncludes}</div>
          </div>
        }

      </div>

      <ScrollRestoration />
    </>
  )
}


